import React, {useEffect} from "react";
import {connect} from "react-redux";
import {fetchResultByType, resultSocket} from "../../redux/actions/resultActions";
import {withTranslation} from "react-i18next";
import _ from "lodash";
import LeftSide from "../../components/live-leap/leftSide";
import RightSide from "../../components/live-leap/rightSide";
import MidSideMt from "../../components/results/mt/midSideMt";
import BodyLive from "../../components/live-leap/body";

const LiveMCPage = (props) => {
    const {
        drawResult: {data},
        historyResult, fetchResultByType, resultSocket, t} = props;
    useEffect(() => {
        let isFetch = false;
        const getResult = () => {
            if (!isFetch) {
                fetchResultByType("mc");
                isFetch = true
            }
        };
        fetchResultByType("mc");
        resultSocket(getResult);
    }, [fetchResultByType, resultSocket]);

    return <div id="mt-result" className="position-relative live">
        <div className="d-flex pt-0 pb-3">
            <LeftSide/>

            {
                _.isEmpty(data) ? <BodyLive t={t} type="mc"/> :
                    <MidSideMt isLive liveClass="live-padding live-mc" isTabView type="vn1" results={historyResult} draw={data} {...props}/>
            }
            <RightSide/>
        </div>
    </div>
};

const mapStateToProps = state => ({
    historyResult: state.resultVn1.result,
    drawResult: state.resultVn1.draw
});

export default connect(
    mapStateToProps,
    {
        fetchResultByType,
        resultSocket
    }
)(withTranslation()(LiveMCPage));
